if (typeof FacetFiltersForm !== 'function') {
	class FacetFiltersForm extends HTMLElement {
		constructor() {
			super();
			this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

			this.debouncedOnSubmit = debounce((event) => {
				this.onSubmitHandler(event);
			}, 500);

			const facetForm = this.querySelector('form');
			facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

			const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
			if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

			this.setDetailsPosition();
		}

		static setListeners() {
			const onHistoryChange = (event) => {
				const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
				if (searchParams === FacetFiltersForm.searchParamsPrev) return;
				FacetFiltersForm.renderPage(searchParams, null, false);
			};
			window.addEventListener('popstate', onHistoryChange);
		}

		static toggleActiveFacets(disable = true) {
			document.querySelectorAll('.js-facet-remove').forEach((element) => {
				element.classList.toggle('disabled', disable);
			});
		}

		static renderPage(searchParams, event, updateURLHash = true) {
			FacetFiltersForm.searchParamsPrev = searchParams;
			const sections = FacetFiltersForm.getSections();

			document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

			sections.forEach((section) => {
				const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
				const filterDataUrl = (element) => element.url === url;

				FacetFiltersForm.filterData.some(filterDataUrl)
					? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
					: FacetFiltersForm.renderSectionFromFetch(url, event);
			});

			if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
		}

		static renderSectionFromFetch(url, event) {
			fetch(url)
				.then((response) => response.text())
				.then((responseText) => {
					const html = responseText;

					FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
					FacetFiltersForm.renderFilters(html, event);
					FacetFiltersForm.renderProductGridContainer(html);

					if (typeof initializeScrollAnimationTrigger === 'function')
						initializeScrollAnimationTrigger(html.innerHTML);
				});
		}

		static renderSectionFromCache(filterDataUrl, event) {
			const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
			FacetFiltersForm.renderFilters(html, event);
			FacetFiltersForm.renderProductGridContainer(html);

			if (typeof initializeScrollAnimationTrigger === 'function')
				initializeScrollAnimationTrigger(html.innerHTML);
		}

		static renderProductGridContainer(html) {
			document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
				.parseFromString(html, 'text/html')
				.getElementById('ProductGridContainer').innerHTML;

			document
				.getElementById('ProductGridContainer')
				.querySelectorAll('.scroll-trigger')
				.forEach((element) => {
					element.classList.add('scroll-trigger--cancel');
				});
			const imagesEvent = new CustomEvent('lazy-image:reload', {
				bubbles: true,
				detail: document.getElementById('ProductGridContainer'),
			});
			document.dispatchEvent(imagesEvent);
		}

		static renderFilters(html, event) {
			const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

			const facetDetailsElements = parsedHTML.querySelectorAll(
				'#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter'
			);
			const matchesIndex = (element) => {
				const jsFilter = event ? event.target.closest('.js-filter') : undefined;
				return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
			};
			const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
			const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
			const resetToRender = Array.from(facetDetailsElements).find(matchesIndex);

			facetsToRender.forEach((element) => {
				document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML =
					element.innerHTML;
			});

			FacetFiltersForm.renderActiveFacets(parsedHTML);
			FacetFiltersForm.renderAdditionalElements(parsedHTML);

			if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
			if (resetToRender) FacetFiltersForm.renderReset(resetToRender, event.target.closest('.js-filter'));
		}

		static renderActiveFacets(html) {
			const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

			activeFacetElementSelectors.forEach((selector) => {
				const activeFacetsElement = html.querySelector(selector);
				if (!activeFacetsElement) return;
				document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
			});

			FacetFiltersForm.toggleActiveFacets(false);
		}

		static renderAdditionalElements(html) {
			const mobileElementSelectors = ['.sorting'];

			mobileElementSelectors.forEach((selector) => {
				if (!html.querySelector(selector)) return;
				document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
			});
		}

		static renderCounts(source, target) {
			const targetElement = target.querySelector('.facets__selected');
			const sourceElement = source.querySelector('.facets__selected');

			const targetElementAccessibility = target.querySelector('.facets__summary');
			const sourceElementAccessibility = source.querySelector('.facets__summary');

			if (sourceElement && targetElement) {
				target.querySelector('.facets__selected').outerHTML =
					source.querySelector('.facets__selected').outerHTML;
			}

			if (targetElementAccessibility && sourceElementAccessibility) {
				target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
			}
		}

		static renderReset(source, target) {
			const headerTargetElement = target.querySelector('.facets__header');
			const headerSourceElement = source.querySelector('.facets__header');
			const footerTargetElement = target.querySelector('.mobile-facets__footer');
			const footerSourceElement = source.querySelector('.mobile-facets__footer');

			if (headerSourceElement && headerTargetElement) {
				target.querySelector('.facets__header').outerHTML = source.querySelector('.facets__header').outerHTML;
			}

			if (footerSourceElement && footerTargetElement) {
				target.querySelector('.mobile-facets__footer').outerHTML =
					source.querySelector('.mobile-facets__footer').outerHTML;
			}
		}

		static updateURLHash(searchParams) {
			history.pushState(
				{ searchParams },
				'',
				`${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
			);

			const mainSearchContainer = document.querySelector('main-search');

			if (mainSearchContainer) {
				mainSearchContainer.dispatchEvent(new CustomEvent('facet-filters-form:change'));
			}
		}

		static getSections() {
			return [
				{
					section: document.getElementById('product-grid').dataset.id,
				},
			];
		}

		createSearchParams(form) {
			const formData = new FormData(form);
			return new URLSearchParams(formData).toString();
		}

		onSubmitForm(searchParams, event) {
			FacetFiltersForm.renderPage(searchParams, event);
		}

		onSubmitHandler(event) {
			event.preventDefault();
			const sortFilterForms = document.querySelectorAll('facet-filters-form form');
			if (event.srcElement.className == 'mobile-facets__checkbox') {
				const searchParams = this.createSearchParams(event.target.closest('form'));
				this.onSubmitForm(searchParams, event);
			} else {
				const forms = [];
				const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

				sortFilterForms.forEach((form) => {
					if (!isMobile) {
						if (
							form.id === 'FacetSortForm' ||
							form.id === 'FacetFiltersForm' ||
							form.id === 'FacetSortDrawerForm'
						) {
							const noJsElements = document.querySelectorAll('.no-js-list');
							noJsElements.forEach((el) => el.remove());
							forms.push(this.createSearchParams(form));
						}
					} else if (form.id === 'FacetFiltersFormMobile') {
						forms.push(this.createSearchParams(form));
					}
				});
				this.onSubmitForm(forms.join('&'), event);
			}
		}

		onActiveFilterClick(event) {
			event.preventDefault();
			FacetFiltersForm.toggleActiveFacets();
			const url =
				event.currentTarget.href.indexOf('?') == -1
					? ''
					: event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
			FacetFiltersForm.renderPage(url);
		}

		setDetailsPosition() {
			if (this.id === 'FacetFiltersFormMobile') return;

			const details = this.querySelectorAll('details');
			details.forEach((detail) => {
				detail.addEventListener('click', (event) => {
					if (!detail.querySelector('.facets__display')) return;

					const rect = detail.getBoundingClientRect();
					const bodyWidth = document.body.clientWidth;
					const displayBox = detail.querySelector('.facets__display');

					if (rect.x < bodyWidth / 2) {
						displayBox.style.left = '-1.2rem';
						displayBox.style.right = 'unset';
					} else {
						displayBox.style.right = '-1.2rem';
						displayBox.style.left = 'unset';
					}
				});
			});
		}
	}

	FacetFiltersForm.filterData = [];
	FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
	FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

	if (!customElements.get('facet-filters-form')) {
		customElements.define('facet-filters-form', FacetFiltersForm);
	}

	FacetFiltersForm.setListeners();
}

if (typeof PriceRange !== 'function') {
	class PriceRange extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				inputs: 'input[type="number"]',
				ranges: 'input[type="range"]',
			};

			// Elements
			this.inputs = this.querySelectorAll(this.selectors.inputs);
			this.minNumberInput = this.inputs[0];
			this.maxNumberInput = this.inputs[1];
			this.ranges = this.querySelectorAll(this.selectors.ranges);
			this.minSliderInput = this.ranges[0];
			this.maxSliderInput = this.ranges[1];
			this.minValue = Number(this.minNumberInput.min);
			this.maxValue = Number(this.maxNumberInput.max);

			this.init();
		}

		init() {
			this.addEventListeners();
		}

		addEventListeners() {
			this.debouncedOnChange = debounce((event) => {
				this.onInputChange(event);
			}, 500);

			this.addEventListener('input', this.onInputChange.bind(this));
		}

		onInputChange(event) {
			this.updateSliderInputs(event);
			this.updateNumberInputs();
		}

		updateNumberInputs() {
			this.minNumberInput.value =
				this.minSliderInput.value !== this.minNumberInput.min ? this.minSliderInput.value : null;

			this.maxNumberInput.value =
				this.maxSliderInput.value !== this.maxNumberInput.max ? this.maxSliderInput.value : null;
		}

		updateSliderInputs(event) {
			const minValue = parseInt(this.minNumberInput.value, 10);
			const maxValue = parseInt(this.maxNumberInput.value, 10);

			if (minValue > maxValue - 10) {
				if (event.target === this.minNumberInput) {
					this.maxSliderInput.value = minValue + 10;

					if (maxValue === this.maxValue) {
						this.minSliderInput.value = this.maxValue - 10;
					}
				} else {
					this.minSliderInput.value = maxValue - 10;
				}
			}

			if (maxValue < minValue + 10) {
				if (event.target === this.maxNumberInput) {
					this.minSliderInput.value = maxValue - 10;

					if (minValue === this.minValue) {
						this.maxSliderInput.value = 10;
					}
				} else {
					this.maxSliderInput.value = minValue + 10;
				}
			}

			if (event.target === this.minNumberInput) {
				this.minSliderInput.value = minValue || Number(this.minNumberInput.min);
			}

			if (event.target === this.maxNumberInput) {
				this.maxSliderInput.value = maxValue || Number(this.maxNumberInput.max);
			}
		}
	}

	if (!customElements.get('price-range')) {
		customElements.define('price-range', PriceRange);
	}
}

if (typeof FacetRemove !== 'function') {
	class FacetRemove extends HTMLElement {
		constructor() {
			super();
			const facetLink = this.querySelector('a');
			facetLink.setAttribute('role', 'button');
			facetLink.addEventListener('click', this.closeFilter.bind(this));
			facetLink.addEventListener('keyup', (event) => {
				event.preventDefault();
				if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
			});
		}

		closeFilter(event) {
			event.preventDefault();
			const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
			form.onActiveFilterClick(event);
		}
	}

	if (!customElements.get('facet-remove')) {
		customElements.define('facet-remove', FacetRemove);
	}
}
